<template>
  <div class="container_box details_box_styles">
    <!--头部信息区域-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <Row type="flex" :gutter="gutterItem">
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ configCharacters(false) + 'SPU：' }}</span>
            <span class="basic_txt" :class="skuInfo.ymsSpu === null ? 'red_txt' : ''">{{ skuInfo.ymsSpu ? skuInfo.ymsSpu : $t('key1000596') }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ configCharacters() + $t('key1000597') }}</span>
            <span class="basic_txt">{{ skuInfo.ymsProductCategoryName }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1000598') }}</span>
            <span class="basic_txt">{{ skuInfo.shelveStatusTxt }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1000599') }}</span>
            <span class="basic_txt" :title="skuInfo.name">{{ skuInfo.name }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1000600') }}</span>
            <span>{{ skuInfo.spu }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1000601') }}</span>
            <span>{{ skuInfo.skuNumber }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1000602') }}</span>
            <span>{{ skuInfo.productGoodsTotalNumber }}</span>
          </Col>
        </Row>
      </Card>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="tableDom"
        highlight-row
        border
        max-height="650"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        :span-method="handleSpan">
      </Table>
    </div>
    <!-- 操作日志 -->
    <operationLogModal
      ref="operationLogTalg"
      :productGoodsId="productGoodsId"
      operationType="sku">
    </operationLogModal>
    <!-- 自营商品操作日志 -->
    <commonLogModal
      ref="commonLog"
      :logMode="isSelfOperated === 1 ? 'SELF_OPERATED_PRODUCT' : 'YMS_STANDARD'"
      operationType="sku"
      :showPage="true">
    </commonLogModal>
    <!--打印预览YMS面单弹窗-->
    <printPreviewWaybillModal
      :printPreviewWaybillTitle="$t('key1000594')"
      :batchPrinting="true"
      :editablePrint="false"
      ref="printPreviewWaybill"
      printType="supplier_viewSku"
      :printUrl="printUrl">
    </printPreviewWaybillModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import operationLogModal from "@/components/common/operationLogModal";
import {
  amountHandel, getBatchCategoryInfoData, getStoreGoodsData, setConfigCharacters,
  batchAllWarehouseData, getSpanMethod, getAllCountrysData, getEnumList, getDataSetBatchList, printProductQRCode
} from "@/utils/common";
import printPreviewWaybillModal from "@/components/common/printPreviewWaybillModal.vue";
import commonLogModal from "@/components/common/commonLogModal.vue";

export default {
  name: "viewSku",
  mixins: [Mixin],
  data() {
    return {
      ItemCol: 6,
      pageParamsStatus: false,
      productId: null,
      skuInfo: {},
      tableData: [],
      productGoodsId: null,
      productColorImageList: [],
      tableColumns: [],
      printUrl: api.post_productGoods_appendProductGoodsExpressBill,
      enumData: [],
      systemType: null
    };
  },
  computed: {
    salesStatusList() {
      const ENUM_KEY = 'ProductGoodsStatusSupplierEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    },
    isSelfOperated() {
      return this.systemType === 'selfOperatedProducts' ? 1 : 0;
    }
  },
  created() {
    let query = this.$route.query;
    if (query) {
      this.productId = query.productId;
      this.systemType = query.systemType;
      this.handleColumns().then(() => {
        (async () => {
          this.enumData = await getDataSetBatchList(['ProductGoodsStatusSupplierEnum']);
        })();
        this.getSkuData(this.productId);
      });
    }
  },
  methods: {
    // 上架、停售sku
    groundingSkuBtn(productGoodsId, status) {
      let v = this;
      let query = {
        productGoodsId: productGoodsId,
        status: status
      };
      let url = v.systemType === 'selfOperatedProducts' ? api.put_productGoods_updateCoreStatus : api.put_productGoods_updateStatus;
      v.axios.put(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          v.getSkuData(this.productId);
        }
      });
    },
    // 删除sku
    deleteSkuBtn(productGoodsId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000584'),
        onOk: () => {
          let url = v.systemType === 'selfOperatedProducts' ? api.delete_ymsProductInfoCore_deleteCore : api.delete_productGoods;
          v.axios.delete(url + productGoodsId, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
              v.getSkuData(this.productId);
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 获取查看sku的数据
    getSkuData(productId) {
      let v = this;
      v.optionBtnWidth = [];
      v.tableData = [];
      if (v.getPermission('productInfo_queryForSkuList') || v.getPermission('ymsProductInfoCore_queryForSkuList')) {
        let url = v.systemType === 'selfOperatedProducts' ? api.get_ymsProductInfoCore_queryForSkuList : api.get_productInfo_queryForSkuList;
        v.axios.get(url + productId, {loading: true}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              // 云卖分类
              let ymsProductCategoryId = data.ymsProductCategoryId;
              let url = v.systemType === 'supplier' ? api.post_ymsProductCategory_api_queryDetailByCategoryIds
                : api.post_ymsProductCategory_queryByYmsProductCategoryIds;
              getBatchCategoryInfoData(url, null, [ymsProductCategoryId], true).then((newData) => {
                if (newData.length > 0) {
                  newData.map((item) => {
                    if (item.ymsProductCategoryId === ymsProductCategoryId) {
                      let txt = item.productCategoryNavigation.split('->');
                      data.ymsProductCategoryName = txt.join(' / ');
                    }
                  });
                }
              });
              // 商品状态
              let shelveStatus = data.shelveStatus;
              v.salesStatusList.map((item) => {
                if (item.value === shelveStatus) {
                  data.shelveStatusTxt = item.title;
                }
              });
              v.skuInfo = data;
              v.productColorImageList = data.productColorImageList || [];
              let productGoodsList = data.productGoodsList || [];
              // 处理货品数据
              if (productGoodsList.length > 0) {
                const newList = [];
                data.productGoodsList.map((item) => {
                  const {productGoodsPrices, wmsInventories, ymsProductGoodsPrices, ymsReportInventories, availableWarehouses, ...vals} = item;
                  // 自营商品
                  if (v.isSelfOperated === 1) {
                    availableWarehouses.forEach(ele => {
                      const obj = {
                        ...ele,
                        skuAllottedNumber: ele.allottedNumber || 0,
                        skuAvailableNumber: ele.availableNumber || 0,
                        warehouseName: ele.name,
                        ...vals,
                      };
                      newList.push(obj);
                    });
                  }
                  // 供应商商品
                  else {
                    const productGoodsPricesList = v.systemType === 'supplier' ? (productGoodsPrices || []) : (ymsProductGoodsPrices || []);
                    const wmsInventoriesList = v.systemType === 'supplier' ? (wmsInventories || []) : (ymsReportInventories || []);
                    // 组装国家供货价数据对象
                    const productGoodsPricesObj = {};
                    productGoodsPricesList.forEach(ele => {
                      const countryCode = ele.countryCode;
                      productGoodsPricesObj[`${countryCode}_supplyPrice`] = ele.supplyPrice;
                    });
                    // 遍历库存数据列表合并
                    wmsInventoriesList.forEach(ele => {
                      const obj = {
                        ...ele,
                        ...productGoodsPricesObj,
                        skuAllottedNumber: ele.allottedNumber || 0,
                        skuAvailableNumber: ele.availableNumber || 0,
                        directShippingPrice: ele.productCost,
                        ymsWarehouseId: ele.warehouseId,
                        ...vals,
                      };
                      newList.push(obj);
                    });
                  }
                });
                v.handleTableData(newList);
              }
            }
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 处理列表数据
    handleTableData(data) {
      if (!data?.length) {
        this.tableData = data || [];
        this.updateTableDom('tableDom');
        return;
      }
      const ymsWarehouseIds = data.map(item => item.warehouseId).filter(Boolean);
      if (!ymsWarehouseIds.length) {
        this.tableData = data;
        this.updateTableDom('tableDom');
        return;
      }
      batchAllWarehouseData(ymsWarehouseIds).then(list => {
        const warehouseMap = {};
        list.forEach(warehouse => {
          let ymsWarehouseDeliverySettings = warehouse.ymsWarehouseDeliverySettings || [];
          let isDeliveryWarehouseTalg = warehouse.isDeliveryWarehouse === 1 && ymsWarehouseDeliverySettings.length > 0;
          warehouse.isDeliveryWarehouseTalg = isDeliveryWarehouseTalg;
          warehouseMap[warehouse.ymsWarehouseId] = warehouse;
        });
        this.tableData = data.map(item => ({
          ...item,
          isDeliveryWarehouseTalg: warehouseMap[item.warehouseId].isDeliveryWarehouseTalg || false,
          warehouseName: warehouseMap[item.warehouseId].name || ''
        }));
        this.updateTableDom('tableDom');
      });
    },
    // 打印条码、打印二维码
    async printBtn(row, type) {
      let v = this;
      if (type === 0) {
        v.$refs['printPreviewWaybill'].initPrintPreviewWaybillData(row, [row]);
      } else {
        let list = [{
          productGoodsId: row.productGoodsId,
          quantity: 1,
          type: type // 0-条形码  1-二维码
        }];
        const data = await printProductQRCode(list)
        if (data) {
          v.commonPrint(data, '1');
        }
      }
    },
    // 处理列表字段
    handleColumns() {
      let v = this;
      v.tableColumns = [];
      let columns = [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000585'),
          key: 'pictureUrl',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            let valueList = [];
            let productGoodsSpecifications = params.row.productGoodsSpecifications || [];
            if (productGoodsSpecifications.length > 0) {
              valueList = productGoodsSpecifications.map((item) => {
                return item.value;
              })
            }
            if (v.productColorImageList.length > 0) {
              let list = v.productColorImageList.filter((ele) => {
                return valueList.includes(ele.color)
              });
              if (list && list.length > 0) {
                let path = list[0].path;
                return v.tableImg(h, params, null, path);
              }
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586'),
          key: 'sku',
          align: 'center',
          minWidth: 180
        },
        {
          title: `${setConfigCharacters(false)}SKU`,
          key: 'ymsSku',
          align: 'center',
          minWidth: 180
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000587'),
          minWidth: 140,
          key: 'specifications',
          align: 'center',
          render(h, params) {
            if (params.row.productGoodsSpecifications) {
              return h('div', {
                style: {
                  color: 'green'
                }
              }, params.row.productGoodsSpecifications.map(i => {
                return h('p', i.name + ':' + i.value);
              }));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000588'),
          minWidth: 220,
          key: 'packageDimensions',
          align: 'center',
          render(h, params) {
            let {length, width, height} = params.row;
            return h('span', length + ' * ' + width + ' * ' + height)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000589'),
          minWidth: 100,
          key: 'weight',
          align: 'center',
          render(h, params) {
            let {weight} = params.row;
            return h('span', weight);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000590'),
          key: 'status',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            let status = params.row.status;
            let isDelete = params.row.isDelete;
            let title = '';
            if (isDelete === 1) {
              title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000591');
            } else {
              v.salesStatusList.map((item) => {
                if (item.value === status) {
                  title = item.title;
                }
              });
            }
            return h('div', {class: isDelete === 1 ? 'redColor' : ''}, title);
          }
        },
      ];
      let columnlist = [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000241'),
          key: 'warehouseName',
          align: 'left',
          minWidth: 160,
          render(h, params) {
            let {warehouseName, ymsWarehouseName} = params.row;
            let name = warehouseName || ymsWarehouseName;
            return h('span', name)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000242'),
          key: 'allottedNumber',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            return h('span', params.row.skuAllottedNumber || 0)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000243'),
          key: 'availableNumber',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            return h('span', params.row.skuAvailableNumber || 0)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000582') + v.currencyState + "）",
          key: 'directShippingPrice',
          align: 'left',
          minWidth: 180,
          render(h, params) {
            let price = params.row.productCost || 0;
            let isDeliveryWarehouseTalg = params.row.isDeliveryWarehouseTalg;
            return h('span', isDeliveryWarehouseTalg ? amountHandel(price) : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000592'))
          }
        }
      ];
      let opts = [{
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
        key: 'options',
        width: 200,
        fixed: 'right',
        align: 'center',
        render: (h, params) => {
          let status = params.row.status;
          let isDelete = params.row.isDelete;
          return h('optsButtonList', {
            props: {
              operationList: [
                {
                  text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000593'), // 运营端先暂时屏蔽掉上架功能,自营商品支持上架商品
                  show: status === 2 && ((v.getPermission('productGoods_updateStatus') && v.systemType === 'supplier')
                    || (v.isSelfOperated === 1 && v.getPermission('productGoods_updateCoreStatus'))),
                  clickFn: () => {
                    if (v.systemTalg) {
                      v.groundingSkuBtn(params.row.productGoodsId, 1);
                    } else {
                      v.groundingSkuBtn(params.row.ymsProductGoodsId, 1);
                    }
                  }
                },
                {
                  text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000539'),
                  show: status === 1 && isDelete !== 1 &&
                    (v.getPermission('productGoods_updateStatus') || v.getPermission('productGoods_updateCoreStatus')),
                  clickFn: () => {
                    if (v.systemTalg) {
                      v.groundingSkuBtn(params.row.productGoodsId, 2);
                    } else {
                      v.groundingSkuBtn(params.row.ymsProductGoodsId, 2);
                    }
                  }
                },
                {
                  text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000288'),
                  show: v.getPermission('productGoodsOperationLog_query') || v.getPermission('ymsProductInfoCore_queryLog'),
                  clickFn: () => {
                    if (v.isSelfOperated === 1) {
                      v.$refs['commonLog'].initCommonLogData(params.row.ymsProductGoodsId);
                    } else {
                      if (v.systemTalg) {
                        v.productGoodsId = params.row.productGoodsId;
                      } else {
                        v.productGoodsId = params.row.ymsProductGoodsId;
                      }
                      v.$refs['operationLogTalg'].initializeData(v.productGoodsId);
                    }
                  }
                },
                {
                  text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000594'),
                  show: v.getPermission('productGoods_appendProductGoodsExpressBill') && v.systemTalg && status !== 0,
                  clickFn: () => {
                    v.printBtn(params.row, 0)
                  }
                },
                {
                  text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000595'),
                  show: v.getPermission('productGoods_appendProductGoodsExpressBill') && v.systemTalg && status !== 0,
                  clickFn: () => {
                    v.printBtn(params.row, 1)
                  }
                },
                {
                  text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                  show: status === 2 && v.systemTalg && v.getPermission('productGoods_delete'),
                  clickFn: () => {
                    v.deleteSkuBtn(params.row.productGoodsId);
                  }
                }
              ]
            },
            on: {
              setWidth(value) {
                if (value) {
                  v.optionBtnWidth.push(value);
                  params.column.width = Math.max(...v.optionBtnWidth);
                  v.$forceUpdate();
                }
              }
            }
          });
        }
      }];
      return new Promise((resolve) => {
        if (v.systemType === 'supplier') {
          getAllCountrysData('cn', true).then((countrysList) => {
            getStoreGoodsData(countrysList).then((nationalSupplyPriceData) => {
              nationalSupplyPriceData.map((item) => {
                let title = item.countryName + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000583') + v.currencyState + "）";
                let key = `${item.twoCode}_supplyPrice`;
                columnlist.unshift({
                  title: title,
                  key: key,
                  minWidth: 220,
                  align: 'left',
                  render: (h, params) => {
                    return h('span', amountHandel(params.row[key]))
                  }
                })
              });
              v.tableColumns = [...columns, ...columnlist, ...opts];
              resolve(true);
            });
          });
        } else {
          let list = columnlist.filter((item) => !['directShippingPrice'].includes(item.key));
          v.tableColumns = [...columns, ...list, ...opts];
          resolve(true);
        }
      });
    },
    // 合并单元格
    handleSpan({row, column, rowIndex, columnIndex}) {
      let colKeys = ['pictureUrl', 'sku', 'ymsSku', 'specifications', 'packageDimensions', 'weight', 'status', 'options'];
      this.tableColumns.map((item) => {
        for (let key in item) {
          if (key.includes('_supplyPrice')) {
            colKeys.push(key);
          }
        }
      })
      colKeys = this.uniqueFunc(colKeys);
      let idField = this.systemType === 'supplier' ? 'productGoodsId' : 'ymsProductGoodsId';
      return getSpanMethod(this.tableData, colKeys, idField, row, column, rowIndex, columnIndex)
    },
  },
  components: {
    commonLogModal,
    printPreviewWaybillModal,
    operationLogModal
  }
};
</script>

<style lang="less" scoped>
.basic_txt {
  max-width: 320px !important;
}

.red_txt {
  color: #E41E09;
}

</style>
